import PropTypes from 'prop-types';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { memo } from 'react';

import CandidateCard from './CandidateCard';
import { ScrollArea } from '@components/common/ScrollArea';

const STATUS_MAPPING = {
    Pending: 'All Candidates',
    Review: 'Review',
    Rejected: 'Rejected',
    Accepted: 'Accepted',
};

const CandidateColumn = memo(({ status, candidates }) => {
    const { setNodeRef, isOver } = useDroppable({
        id: status,
    });

    return (
        <div className="space-y-4 w-full">
            <div className="flex items-center justify-between bg-white rounded-lg px-4 h-11 box-border">
                <h2 className="text-sm font-semibold capitalize">{STATUS_MAPPING[status]}</h2>
                <span className="text-sm text-gray-500">
                    {candidates.length} {candidates.length === 1 ? 'candidate' : 'candidates'}
                </span>
            </div>
            <ScrollArea className="h-[calc(100vh-340px)]">
                <div
                    ref={setNodeRef}
                    className={`min-h-[100px] transition-colors ${
                        isOver ? 'bg-blue-50 rounded-lg' : ''
                    }`}
                >
                    <SortableContext
                        items={candidates.map(c => c.id)}
                        strategy={verticalListSortingStrategy}
                    >
                        {candidates.map(candidate => (
                            <CandidateCard
                                key={`card-${candidate.id}`}
                                candidate={candidate}
                                isOver={isOver}
                            />
                        ))}
                    </SortableContext>
                    {candidates.length === 0 && (
                        <div className="h-24 flex items-center justify-center text-gray-400 border-2 border-dashed border-gray-200 rounded-lg">
                            Drop candidate here
                        </div>
                    )}
                </div>
            </ScrollArea>
        </div>
    );
});

CandidateColumn.displayName = 'CandidateColumn';

CandidateColumn.propTypes = {
    status: PropTypes.oneOf(['Pending', 'Review', 'Rejected', 'Accepted']).isRequired,
    candidates: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            candidate_name: PropTypes.string.isRequired,
            candidate_mob_no: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            status: PropTypes.string.isRequired,
            image: PropTypes.string,
            lastUpdated: PropTypes.string,
        }),
    ).isRequired,
};

export default CandidateColumn;
